// extracted by mini-css-extract-plugin
var _1 = "signatureForm__YZDUE";
export { _1 as "signatureForm" }
